module.exports = __webpack_public_path__ + "img/451d6ab8081a12e8ad1b522ad7c7edaf.451d6ab8.png";